import type { FProject } from "@piperunner-cms/types/v1";
import type { StateCreator } from "zustand";
import type { ProfileStore, State } from "./types";

export const createProfileStore: StateCreator<State, [], [], ProfileStore> = (set) => ({
  user: undefined,
  isNewUser: undefined,
  setIsNewUser: (isNewUser) => {
    set({ isNewUser });
  },
  setUser: (currentUser) => {
    set({
      user: currentUser
        ? {
            uid: currentUser.uid,
            email: currentUser.email ?? "",
            profilePictureUrl: currentUser.photoURL ?? undefined,
            displayName: currentUser.displayName ?? undefined,
            emailVerified: currentUser.emailVerified,
            refreshToken: currentUser.refreshToken ?? "",
          }
        : null,
    });
  },
  // userRole: "guest",
  // setUserRole: (userRole) => {
  //   set({ userRole });
  // },
  projects: undefined,
  setProjects: (projects) => {
    set({ projects });
  },
  activeProjectId: undefined,
  setActiveProjectId: (projectId: FProject["id"]) => {
    set({ activeProjectId: projectId });
  },
});
